import Vue from 'vue'
import VueI18n from 'vue-i18n'
import JTF from '@beetronix/jtf'
import { eStorage } from '@beetronix/estorage'

import sharedTranslates from './shared-translations.json'
import routesTitles from './routes-titles.json'
import headers from './headers.json'
import inputs from './inputs.json'

Vue.use(VueI18n)
Vue.use(JTF)

const jtf = new JTF({
	locales: require.context('./locales'),
	sharedTranslates: [
		{ translates: sharedTranslates },
		{ translates: routesTitles, prefixKey: 'routes' },
		{ translates: headers, prefixKey: 'headers' },
		{ translates: inputs, prefixKey: 'inputs' },
	]
})

const i18n = new VueI18n({
	locale: process.env.VUE_APP_I18N_LOCALE || 'ar',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ar',
	messages: jtf.loadMessages()
})

export function changeI18nLang(lang = 'en') {
	if (lang === 'ar') {
		document.querySelector('html').dir = 'rlt';
	} else {
		document.querySelector('html').dir = 'rlt';
	}
	eStorage.l.set('lang', lang);
	i18n.locale = lang;
}

if (eStorage.l.has('lang')) {
	changeI18nLang(eStorage.l.get('lang'));
} else {
	changeI18nLang('ar');
}

export default i18n;